module.exports = __webpack_public_path__ + "static/teetherorganicmain-934d2710d9da41f4034d595effa9be63.jpeg";